import { MetStatus } from "./types";

export function roundToTwo(num: number): number {
  if (!num && num !== 0) return 0;
  return +(Math.round(Number.parseFloat(num.toString() + "e+2")) + "e-2");
}

/** Converts 'toohight' (backend typo) to 'toohigh' and validates the status value */
export function normalizeStatus(status: string | undefined | null): MetStatus {
  if (!status) return "not-applicable";
  const normalized = status.toLowerCase().trim();
  if (normalized === "toohight") return "toohigh";
  if (normalized === "met" || normalized === "notmet" || normalized === "toohigh" || normalized === "not-applicable") {
    return normalized as MetStatus;
  }
  return "not-applicable";
}

/** met → green, toohigh → orange, notmet/not-applicable → red */
export function statusToColor(status: MetStatus): string {
  if (status === "met") return "#00AA00";
  if (status === "toohigh") return "#FF8C00";
  return "#CC0000";
}

export function checkMetStatus(value: number, target: number, comparison: "gte" | "lte" = "gte", highThreshold?: number): MetStatus {
  if (comparison === "gte") {
    if (value >= target) {
      if (highThreshold !== undefined && value > highThreshold) return "toohigh";
      return "met";
    }
    return "notmet";
  }
  // lte comparison (for fTI where lower is better)
  return value <= target ? "met" : "notmet";
}

export function getStatusText(status: MetStatus, t: (key: string) => string): string {
  switch (status) {
    case "met":
      return t("met");
    case "notmet":
      return t("not met");
    case "toohigh":
      return t("too high");
    default:
      return "";
  }
}
